const getters = {
  user: (state) => (state.user.email !== null ? state.user : null),
  justAddedContacts: (state) => {
    // eslint-disable-next-line no-console
    console.log('Getter accessed:', state.addedContacts);//undefined.
    return state.addedContacts;
  },
  firstName: (state) => state.user.firstName ?? null,
  email: (state) => state.user.email,
  addresses: (state) => state.user.addresses.edges,
  addressById: (state) => (id) =>
    state.user.addresses.edges.find((address) => address.node.id === id),
  hasOrders: (state) => state.user.orders.edges.length > 0,
  hasWishlist: (state) => state.wishlist.length > 0 || false,
  inWishlist: (state) => (id) =>
    Array.isArray(state.wishlist) ? state.wishlist.includes(id) : false,
  wishlist: (state) => (Array.isArray(state.wishlist) ? state.wishlist : []),
  userEmailToken: (state) => state.user.token ?? null
};
export default getters;
